import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const tetrahedron = geo.createNode('tetrahedron');
	tetrahedron.p.radius.set(1);
	tetrahedron.p.center.set([0, 0, 0]);
	tetrahedron.p.detail.set(5);
	tetrahedron.p.pointsOnly.set(false);

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [tetrahedron],
		autoLayout: true,
	};
}
// export const sopTetrahedron = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/tetrahedron`,
// 		createData,
// 		relatedNodes: [TetrahedronSopNode],
// 	}),
// ];
